type ErrorViewProps = {
  isVisible: boolean;
  title: string | undefined;
};

/**
 * A component that displays an error message.
 *
 * @param {{isVisible: boolean, title: string}} props
 * @param {boolean} props.isVisible - Whether the error view is visible or not.
 * @param {string} props.title - The title of the error to display.
 * @returns {React.ReactElement} - The error view component to render.
 */
export default function ErrorView({ isVisible, title }: ErrorViewProps) {
  if (!isVisible) return null;
  return (
    <div className="bg-red-100 border border-red-300 text-red-700 px-4 py-3 rounded mb-4">
      {title}
    </div>
  );
}
